import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "bg-gray-50 p-2 rounded border border-gray-200 text-xs leading-tight mb-2"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  class: "py-1"
};
const _hoisted_5 = {
  class: "bg-white border border-gray-200 rounded p-2 mb-2"
};
const _hoisted_6 = {
  class: "bg-white border border-gray-200 rounded p-2"
};
const _hoisted_7 = {
  key: 0,
  class: "mt-1"
};
const _hoisted_8 = {
  class: "text-error text-xs mt-1"
};
const _hoisted_9 = {
  class: "text-gray-500 text-xs mt-1"
};
import { onMounted, reactive } from 'vue';
import { useExpenseSettingStore } from './expenseSettingStore.js';
import LlSelect from '@/components/LlSelect.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlTextField from '@/components/LlTextField.vue';
export default {
  __name: 'AccountSetup',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    accountingService: {
      type: Object,
      required: true
    },
    companyBillingState: {
      type: Object,
      required: true
    },
    messageText: {
      type: String,
      required: true
    },
    expenseWizardState: {
      type: Object,
      required: true
    },
    modalValue: {
      type: Object,
      required: true
    },
    accounts: {
      type: Array,
      required: true
    },
    qboType: {
      type: String,
      required: true
    },
    qboSubtype: {
      type: String,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const accountSetupState = reactive({
      loading: false,
      account: {},
      create: false
    });
    const expenseSettingStore = useExpenseSettingStore();
    onMounted(async () => {
      accountSetupState.loading = true;
      accountSetupState.name = props.modalValue.name;
      if (expenseSettingStore.data.step === 1) {
        accountSetupState.account = props.expenseWizardState?.data?.incomeAccount?.account;
        accountSetupState.create = props.expenseWizardState?.data?.incomeAccount?.create;
        props.expenseWizardState?.data?.incomeAccount?.account?.name;
      } else if (expenseSettingStore.data.step === 4) {
        accountSetupState.account = props.expenseWizardState?.data?.hardAccount?.account;
        accountSetupState.create = props.expenseWizardState?.data?.hardAccount?.create;
      } else if (expenseSettingStore.data.step === 8) {
        accountSetupState.account = expenseSettingStore.data.softAccount.account;
        accountSetupState.create = props.expenseWizardState?.data?.softAccount?.create;
      }
      accountSetupState.loading = false;
    });
    const changeAccountType = account => {
      accountSetupState.create = false;
      if (expenseSettingStore.data.step === 1) {
        props.expenseWizardState.data.incomeAccount.account = account;
        expenseSettingStore.data.incomeAccount.account = account;
        expenseSettingStore.data.incomeAccount.create = false;
      } else if (expenseSettingStore.data.step === 4) {
        props.expenseWizardState.data.hardAccount.account = account;
        expenseSettingStore.data.hardAccount.account = account;
        expenseSettingStore.data.hardAccount.create = false;
      } else if (expenseSettingStore.data.step === 8) {
        props.expenseWizardState.data.softAccount.account = account;
        expenseSettingStore.data.softAccount.account = account;
        expenseSettingStore.data.softAccount.create = false;
      }
    };
    const exists = () => {
      return props.accounts?.filter(c => c.name === accountSetupState.name).length > 0;
    };
    const createAccount = create => {
      accountSetupState.account = '';
      accountSetupState.create = create;
      if (expenseSettingStore.data.step === 1) {
        props.expenseWizardState.data.incomeAccount.create = create;
        expenseSettingStore.data.incomeAccount.create = create;
        props.expenseWizardState.data.incomeAccount.account = {};
        expenseSettingStore.data.incomeAccount.account = {};
      } else if (expenseSettingStore.data.step === 4) {
        props.expenseWizardState.data.hardAccount.create = create;
        expenseSettingStore.data.hardAccount.create = create;
        props.expenseWizardState.data.hardAccount.account = {};
        expenseSettingStore.data.hardAccount.account = {};
      } else if (expenseSettingStore.data.step === 8) {
        props.expenseWizardState.data.softAccount.create = create;
        expenseSettingStore.data.softAccount.create = create;
        props.expenseWizardState.data.softAccount.account = {};
        expenseSettingStore.data.softAccount.account = {};
      }
    };
    const createNewAccount = () => {
      if (expenseSettingStore.data.step === 1) {
        props.expenseWizardState.data.incomeAccount.name = accountSetupState.name;
        props.expenseWizardState.data.incomeAccount.type = props.qboType;
        props.expenseWizardState.data.incomeAccount.subtype = props.qboSubtype;
        expenseSettingStore.data.incomeAccount.name = accountSetupState.name;
        expenseSettingStore.data.incomeAccount.type = props.qboType;
        expenseSettingStore.data.incomeAccount.subtype = props.qboSubtype;
      } else if (expenseSettingStore.data.step === 4) {
        props.expenseWizardState.data.hardAccount.name = accountSetupState.name;
        props.expenseWizardState.data.hardAccount.type = props.qboType;
        props.expenseWizardState.data.hardAccount.subtype = props.qboSubtype;
        expenseSettingStore.data.hardAccount.name = accountSetupState.name;
        expenseSettingStore.data.hardAccount.type = props.qboType;
        expenseSettingStore.data.hardAccount.subtype = props.qboSubtype;
      } else if (expenseSettingStore.data.step === 8) {
        props.expenseWizardState.data.softAccount.name = accountSetupState.name;
        props.expenseWizardState.data.softAccount.type = props.qboType;
        props.expenseWizardState.data.softAccount.subtype = props.qboSubtype;
        expenseSettingStore.data.softAccount.name = accountSetupState.name;
        expenseSettingStore.data.softAccount.type = props.qboType;
        expenseSettingStore.data.softAccount.subtype = props.qboSubtype;
      }
    };
    return (_ctx, _cache) => {
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_container = _resolveComponent("v-container");
      return accountSetupState.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_progress_circular, {
        color: "success",
        indeterminate: ""
      })])) : (_openBlock(), _createBlock(_component_v_container, {
        key: 1,
        class: "w-full h-full pa-2"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
          innerHTML: __props.messageText
        }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "flex items-center text-sm mb-1"
        }, [_createElementVNode("img", {
          src: "/img/qb16x16.png",
          style: {
            "margin-right": "6px",
            "height": "14px",
            "width": "14px"
          }
        }), _createElementVNode("strong", null, "Pick existing account")], -1)), _createVNode(LlSelect, {
          items: __props.accounts,
          modelValue: accountSetupState.account,
          "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => accountSetupState.account = $event), changeAccountType],
          "item-value": 'id',
          "item-title": item => item.label ? item.label : item.name,
          "return-object": true,
          clearable: true,
          "is-autocomplete": true,
          placeholder: "Select Account",
          "hide-details": true,
          class: "w-full"
        }, null, 8, ["items", "modelValue", "item-title"])]), _cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "text-center py-1 mb-1"
        }, [_createElementVNode("span", null, [_createElementVNode("em", null, "- or -")])], -1)), _createElementVNode("div", _hoisted_6, [_createVNode(LlCheckbox, {
          modelValue: accountSetupState.create,
          "onUpdate:modelValue": [_cache[1] || (_cache[1] = $event => accountSetupState.create = $event), createAccount],
          label: "Create a new account in QuickBooks"
        }, null, 8, ["modelValue"]), accountSetupState.create ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(LlTextField, {
          modelValue: accountSetupState.name,
          "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => accountSetupState.name = $event), createNewAccount],
          disabled: !accountSetupState.create,
          placeholder: "Account name",
          "hide-details": true,
          class: "w-full"
        }, null, 8, ["modelValue", "disabled"]), _withDirectives(_createElementVNode("div", _hoisted_8, [...(_cache[4] || (_cache[4] = [_createElementVNode("span", {
          class: "fa fa-warning"
        }, null, -1), _createTextVNode(" Name exists ", -1)]))], 512), [[_vShow, exists()]]), _createElementVNode("p", _hoisted_9, [_cache[5] || (_cache[5] = _createTextVNode(" Type: ", -1)), _createElementVNode("strong", null, _toDisplayString(__props.qboType), 1), _cache[6] || (_cache[6] = _createTextVNode(", Subtype: ", -1)), _createElementVNode("strong", null, _toDisplayString(__props.qboSubtype), 1)])])) : _createCommentVNode("", true)])])]),
        _: 1
      }));
    };
  }
};